import { RadarLoaderLarge } from "./ui/RadarLoader.jsx";

/**
 * LoadingOverlay — fullscreen blocking overlay shown during:
 *   - initial data fetch (first app load)
 *   - WS-reconnect resync on data-dependent routes (tab returned from
 *     background and real-time state may be stale)
 *
 * The overlay itself handles:
 *   - Fullscreen positioning + backdrop blur
 *   - Click-through suppression (pointer-events-auto)
 *   - z-index above the WS banner and Leaflet panes
 *   - Fade-in animation to avoid flashing on sub-150ms loads
 *
 * The actual spinner visual is delegated to <RadarLoaderLarge/>, which
 * owns the radar-themed look + \"Cargando...\" label. Keeping the wrapper
 * separate means other pages/contexts can reuse the radar loader
 * without inheriting the overlay behavior.
 */
export default function LoadingOverlay({
  show,
  message = "Cargando",
  subMessage = null,
}) {
  if (!show) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="fixed inset-0 z-[2000] flex items-center justify-center bg-background-dark/85 backdrop-blur-sm pointer-events-auto animate-[loading-fade-in_150ms_ease-out]"
    >
      <RadarLoaderLarge label={message} subLabel={subMessage} />

      {/* Keyframe kept inline so this component is self-contained and doesn't
          depend on Tailwind config changes. */}
      <style>{`
        @keyframes loading-fade-in {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
